import { useSelector } from 'react-redux';
import { selectEnableLiveCasino3 } from '~/components/brand/ducks/selectors';
import GameInfoOld from './game-info-old';
import GameInfoNew from './game-info-new';

const GameInfo = () => {
	const isNewInfoPageEnabled = useSelector(selectEnableLiveCasino3);

	if (isNewInfoPageEnabled) {
		return <GameInfoNew />;
	}

	return <GameInfoOld />;
};

export default GameInfo;
